import {prepSigilMeta} from './team_sigil'

export function tagsToOptions(tags, teams) {
    return tags
        .filter(t => !!t)
        .map(tag => ({...tag, teams, label: tag.name, value: tag.name, teamSigil: prepSigilMeta(teams[tag.teamId]) }))
}

export function hydrateTagComboOptions(recentTagCombos, tagMap, teams) {
    return recentTagCombos.map(combo => {
        if (Object.keys(tagMap) <= 1) return {name: '', label: ''}
        const hydratedTags = combo.tags.map(id => tagMap[id])
        const tagOptions = tagsToOptions(hydratedTags, teams)
        const optionLabels = tagOptions.reduce((acc, c) => [...acc, c.label], [])
        return {combo: true, tags: tagOptions, value: combo.id, label: optionLabels.join(',')}
    })
}


// WEBPACK FOOTER //
// ./src/common/components/tag_select.js